import { SettingOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useState } from "react";
import PropTypes from "prop-types";

import { TableExtractionSettingsModal } from "./TableExtractionSettingsModal";

function TableExtractionSettingsBtn({
  promptId,
  enforceType,
  setAllTableSettings,
}) {
  const [openSettingsModal, setOpenSettingsModal] = useState(false);

  return (
    <>
      <Tooltip title="Table Extraction Settings">
        <Button
          size="small"
          type="text"
          onClick={() => setOpenSettingsModal(true)}
        >
          <SettingOutlined />
        </Button>
      </Tooltip>
      <TableExtractionSettingsModal
        open={openSettingsModal}
        setOpen={setOpenSettingsModal}
        promptId={promptId}
        enforceType={enforceType}
        setAllTableSettings={setAllTableSettings}
      />
    </>
  );
}

TableExtractionSettingsBtn.propTypes = {
  promptId: PropTypes.string.isRequired,
  enforceType: PropTypes.string.isRequired,
  setAllTableSettings: PropTypes.func.isRequired,
};

export { TableExtractionSettingsBtn };
